"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function DollarPlain16Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 2C7 1.44772 7.44772 1 8 1C8.55228 1 9 1.44772 9 2V3.0389C10.0483 3.14905 11.0827 3.48852 11.8277 3.99815L11.0239 5.56932C10.1244 5.03327 8.99518 4.70055 8.09567 4.70055C7.23443 4.70055 6.60285 4.97782 6.60285 5.68022C6.60285 6.4336 7.53971 6.7042 8.63276 7.01992C10.1679 7.46332 12.0111 7.99572 11.9999 10.0795C11.9999 11.7916 10.6594 12.7028 9 12.938V14C9 14.5523 8.55228 15 8 15C7.44772 15 7 14.5523 7 14V12.9159C5.8647 12.7424 4.76785 12.3038 4 11.6322L4.78468 10.1165C5.66506 10.8743 7.08132 11.3364 8.19136 11.3364C9.12915 11.3364 9.85642 11.0222 9.85642 10.2828C9.85642 9.41744 8.86784 9.13176 7.74139 8.80625C6.24521 8.37388 4.50582 7.87124 4.51674 5.84658C4.51674 4.29657 5.60131 3.43745 7 3.13079V2Z", fill: "#383F49" }));
}
function DollarPlain16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(DollarPlain16Svg, Object.assign({}, svgProps)));
}
exports.default = DollarPlain16;
//# sourceMappingURL=DollarPlain16.js.map